import { assertNever } from "../../errors";

import { AgentChatMessageSource } from "./agentChatMessageTypes";

/**
 * User-facing display names for each `AgentChatMessageSource`.
 *
 * Declaring this as a `Record<AgentChatMessageSource, string>` forces every
 * new source variant to have a display name at compile time -- so additions
 * to the enum can't silently drift away from UI surfaces that label sources.
 */
export const AGENT_CHAT_MESSAGE_SOURCE_DISPLAY_NAME: Record<
  AgentChatMessageSource,
  string
> = {
  [AgentChatMessageSource.HEX]: "Hex",
  [AgentChatMessageSource.SLACK]: "Slack",
  [AgentChatMessageSource.MCP]: "MCP",
  [AgentChatMessageSource.TASK]: "Task",
  [AgentChatMessageSource.PUBLIC_API]: "API",
};

export function isExternalAgentSource(
  source: AgentChatMessageSource | null,
): boolean {
  switch (source) {
    // A null source means that the thread originated in Hex.
    case null:
      return false;
    case AgentChatMessageSource.HEX:
    // Tasks are internal to Hex but are also headless
    case AgentChatMessageSource.TASK:
      return false;
    case AgentChatMessageSource.SLACK:
    case AgentChatMessageSource.MCP:
    case AgentChatMessageSource.PUBLIC_API:
      return true;
    default:
      assertNever(source, source);
  }
}

export function isHeadlessAgentSource(
  source: AgentChatMessageSource | null,
): boolean {
  switch (source) {
    // A null source means that the thread originated in Hex.
    case null:
      return false;
    case AgentChatMessageSource.HEX:
      return false;
    case AgentChatMessageSource.SLACK:
    case AgentChatMessageSource.MCP:
    case AgentChatMessageSource.TASK:
    case AgentChatMessageSource.PUBLIC_API:
      return true;
    default:
      assertNever(source, source);
  }
}
